/**
 * Dentrix schedule demo wiring.
 *
 * The Dentrix sandbox schedule page positions `<a data-schedule-slot>`
 * anchors over its appointment blocks. Each slot is filled, in document
 * order, with the next patient from the shared demo list — name rendered
 * "Last, First" like real Dentrix — and linked to the patient chart page
 * for that patient (`chart.html?patient=<id>`), where the dock buttons
 * pick up the patient context.
 */

import { DEMO_PATIENT_OPTIONS } from './demo-patients';
import { formatPatientName } from './demo-patient-profile';

/**
 * Fills every `[data-schedule-slot]` anchor with a demo patient name and a
 * chart deep link. Slots beyond the patient list are left untouched; pages
 * without slots are a no-op.
 *
 * @param doc - Demo document containing the schedule page
 */
export function wireDentrixSchedule(doc: Document): void {
  const slots = doc.querySelectorAll<HTMLAnchorElement>('a[data-schedule-slot]');
  slots.forEach((slot, index) => {
    const row = DEMO_PATIENT_OPTIONS[index];
    if (!row) return;
    slot.setAttribute('href', `chart.html?patient=${encodeURIComponent(row.patientId)}`);
    const nameEl = slot.querySelector('.appt-name') ?? slot;
    nameEl.textContent = formatPatientName(row.fullName, 'last-first');
  });
}
